module.exports = __webpack_public_path__ + "img/logo.9d96b4c7.png";